










































































































import moment from 'moment';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Booking } from '@/api';

@Component({
  components: {},
})
export default class extends Vue {
  @Prop({ required: false }) readonly routeTitle: string;

  loading: boolean = false;

  importsDateMenu: boolean = false;
  importsDate: string = moment().format('YYYY-MM-DD');
  bookings: Booking[] = [];

  get formattedimportsDate() {
    if (!this.importsDate) {
      return '';
    }
    return moment(this.importsDate, 'YYYY-MM-DD').format('D/M/YYYY');
  }

  formatTime(date: string) {
    return moment(date).format('HH:mm');
  }

  formatCurrency(amount: string) {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
    }).format(Number(amount));
  }

  prevDate() {
    this.importsDate = moment(this.importsDate, 'YYYY-MM-DD')
      .subtract(1, 'day')
      .format('YYYY-MM-DD');
  }

  nextDate() {
    this.importsDate = moment(this.importsDate, 'YYYY-MM-DD')
      .add(1, 'day')
      .format('YYYY-MM-DD');
  }

  async updateDiary() {
    try {
      this.loading = true;
      const start = moment(this.importsDate, 'YYYY-MM-DD').toISOString();
      const end = moment(this.importsDate, 'YYYY-MM-DD')
        .endOf('day')
        .toISOString();
      this.bookings = (
        await Booking.includes(['airlineOut', 'airlineIn', 'lot'])
          .where({ payment_datetime__gte: start, payment_datetime__lte: end })
          .order({ paymentDatetime: 'asc' })
          .per(1000)
          .all()
      ).data;
    } catch (err) {
      // Error
    } finally {
      this.loading = false;
    }
  }

  mounted() {
    if (this.$route.query.imports_date) {
      this.importsDate = moment(
        this.$route.query.imports_date.toString(),
      ).format('YYYY-MM-DD');
    }
    this.updateDiary();
  }

  @Watch('importsDate')
  dateChanged() {
    this.updateDiary();

    if (this.importsDate !== this.$route.query.imports_date) {
      this.$router.replace({
        name: 'admin-imports',
        query: { imports_date: this.importsDate },
      });
    }
  }
}
